import React, { useEffect, useState } from "react";
import { FaPlusSquare } from "react-icons/fa";
import MetricCards from "./MetricCards";
import DataTables from "./DataTables";
import { Funnel } from "lucide-react";
import { Badge, Button, Input } from "reactstrap";

export default function Visitor() {
 const [searchQuery, setSearchQuery] = useState("");
const [data, setData] = useState([]);
const [filteredData, setFilteredData] = useState([]);
const [showFilters, setShowFilters] = useState(false);
const [loading, setLoading] = useState(true);

const [filters, setFilters] = useState({
  startDate: "",
  endDate: "",
  formSubmitted: "",
  visitorType: "",
});

 const proxyUrl = "https://api.allorigins.win/raw?url=";
const targetUrl = "https://stg.c-zentrix.com/visitors_new.json";

// fetch data only once
useEffect(() => {
    async function fetchData() {
    try {
      const response = await fetch(proxyUrl+targetUrl, {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      if (!response.ok) {
        throw new Error(
          `Failed to fetch data: ${response.status} ${response.statusText}`
        );
      }

      const result = await response.json();
      setData(result);
      setFilteredData(result);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
  fetchData();
}, []);

  useEffect(() =>{
    if(data.length > 0){

    setFilteredData(data)
    setLoading(false)
    }
  },[data])

const handleFilterChange = (e) => {
  const { name, value } = e.target;
  setFilters((prev) => ({ ...prev, [name]: value }));
};

// ✅ Only filter when user clicks Apply
const applyFilters = () => {
  let temp = [...data];
  console.log(temp)
  console.log(filters.startDate, filters.endDate)

  if (filters.startDate && filters.endDate) {
    console.log("neha")
  const start = new Date(filters.startDate);
  start.setHours(0, 0, 0, 0); 

  const end = new Date(filters.endDate);
  end.setHours(23, 59, 59, 999); 

  temp = temp.filter((item) => {
    const visitDate = new Date(item.time); 
    return visitDate >= start && visitDate <= end;
    
  });
  console.log(temp)
}

  if (filters.formSubmitted) {
    temp = temp.filter(
      (item) =>
        String(item.form_submitted).toLowerCase() ===
        filters.formSubmitted.toLowerCase()
    );
  }

  if (filters.visitorType) {
    temp = temp.filter(
      (item) =>
        item.visitorType &&
        item.visitorType
          .toLowerCase()
          .includes(filters.visitorType.toLowerCase())
    );
  }

  setFilteredData(temp);
  setShowFilters(false)
};

const clearFilters = () => {
  setFilters({
    startDate: "",
    endDate: "",
    formSubmitted: "",
    visitorType: "",
  });
  setFilteredData(data); // reset to full data
  setShowFilters(false); // hide filter panel
};

console.log("data:", filteredData)
  return (
    <div>
      <section className="dash-section">
        <div className="container-fluid p-0">
          <div className="row p-0 m-0">
            <div className="col-lg-12 col-md-7 col-sm-12 right-content">
              <div className="head-name">
                <h3>Visitor Analytics</h3>
              </div>

             <div className="bg-[#e3e3e336] p-4">
                <div className="top-button d-flex  justify-end align-items-center gap-2">

                  <Badge
                    color="primary"
                    style={{
                      color: "#fff",
                      fontSize: "0.9rem",
                      backgroundColor: "#530cb3",
                      cursor: "pointer",
                    }}
                    className="custom-badge d-inline-flex mb-4 align-items-center px-4 py-3 rounded-pill"
                    onClick={() => setShowFilters((prev) => !prev)}
                  >
                    <Funnel size={18} className="me-2" />
                    Filters
                  </Badge>
                </div>

                {/* Filter Panel */}
                {showFilters && (
                  <div className="filter-panel bg-white mb-3 p-3 mt-1 rounded shadow-sm">
                    <div className="row g-3">
                      <div className="col-md-3">
                        <label className="form-label">Start Date</label>
                        <Input
                          type="date"
                          name="startDate"
                          value={filters.startDate}
                          onChange={handleFilterChange}
                        />
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">End Date</label>
                        <Input
                          type="date"
                          name="endDate"
                          value={filters.endDate}
                          onChange={handleFilterChange}
                        />
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">Form Submitted</label>
                        <Input
                          type="select"
                          name="formSubmitted"
                          value={filters.formSubmitted}
                          onChange={handleFilterChange}
                        >
                          <option value="">Select</option>
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </Input>
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">Visitor Type</label>
                        <Input
                          type="select"
                          name="visitorType"
                          value={filters.visitorType}
                          onChange={handleFilterChange}
                          placeholder="e.g. new, returning"
                        >
                            <option value="">Select</option>
                          <option value="subscribe">Subscribe</option>
                          <option value="callback">Callback</option>
                          <option value="demo">Demo</option>
                          <option value="ebook">Ebook</option>
                          <option value="freeDemo">Free Trail Demo</option>
                           <option value="casestudy">Casestudy</option>
                          <option value="career">Career</option>
                          <option value="webinar">Webinar</option>
                          <option value="blog">Blog Lead</option>
                        </Input>
                      </div>
                    </div>

   <div className="d-flex justify-content-end mt-3 gap-2">
      <Button color="secondary" onClick={clearFilters}>
        Clear
      </Button>
      <Button color="success" onClick={applyFilters}>
        Apply
      </Button>
    </div>
                  </div>
                )}

                {/* Data */}
               {loading ? (
            <p>Loading visitors...</p>
            ) : (
            <>
                {filteredData.length > 0 ? (
                <>
                    <MetricCards data={filteredData} />
                    <DataTables data={filteredData} />
                </>
                ) : (
                <div className="text-center py-5 text-gray-600">
                    No data found for the selected filters.
                </div>
                )}
            </>
            )}


              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
